export const locale = {
  lang: 'en',
  data: {
    CENTER_MANAGEMENT: {
      "TITLE": "Users",
      "INTRO": "Manage your center users.",
      "USERS": "Users",
      "DETAILS": "Center details",
      "PDF": "PDF customization",
      "INVITE": "Invite user",
      "EDIT": "Edit user",
      "NAME": "First name",
      "LAST_NAME": "Last name",
      "EMAIL": "Email address",
      "ROLE": "Role",
      "EMPLOYEE": "User",
      "ADMIN": "Center administrator",
      "STATUS": "Status",
      "ACTIONS": "Actions",
      "INVITE_HELP": "We will send a link valid for 7 days so they can set their password.",
      "EMAIL_HELP": "The email identifies the account. For a different address, deactivate this account and invite the new address.",
      "CONFIRM_ROLE": "This changes center management permissions. Do you want to continue?",
      "CONFIRM": "Confirm",
      "SAVE": "Save",
      "CANCEL": "Cancel",
      "CONFIRM_ACTIVATE": "Reactivate access for this user?",
      "CONFIRM_DEACTIVATE": "Access will be blocked and pending invitations cancelled. Deactivate this user?",
      "SEARCH": "Search by name or email",
      "SEARCH_BUTTON": "Search",
      "LOADING": "Loading users…",
      "RESEND": "Resend invitation",
      "REVOKE": "Cancel invitation",
      "DEACTIVATE": "Deactivate",
      "ACTIVATE": "Reactivate",
      "EMPTY": "No users match your search.",
      "EMPTY_INITIAL": "No users yet",
      "EMPTY_HELP": "Invite your team to give them access to your center.",
      "EMPTY_SEARCH_HELP": "Try a different name or email.",
      "COUNT_ONE": "{{ count }} user",
      "COUNT_OTHER": "{{ count }} users",
      "PREVIOUS": "Previous",
      "NEXT": "Next",
      "active": "Active",
      "inactive": "Inactive",
      "invited": "Invitation pending",
      "expired": "Invitation expired",
      "revoked": "Invitation cancelled",
      "EMAIL_FAILED": "The account was saved, but the email could not be sent. You can resend the invitation.",
      "INVITED_OK": "Invitation sent.",
      "SAVED": "Changes saved.",
      "EMAIL_EXISTS": "A user with this email address already exists.",
      "ERROR": "The operation could not be completed. Please try again.",
      "ACCEPT_TITLE": "Join your center",
      "ACCEPT_HELP": "Set your password to activate your account and access your center.",
      "ACCEPTED": "Your account is active. You can now sign in.",
      "LOGIN": "Sign in",
      "PASSWORD": "Password",
      "PASSWORD_HELP": "Use at least 8 characters, one uppercase letter, and one number.",
      "REPEAT_PASSWORD": "Repeat password",
      "PASSWORD_MISMATCH": "Passwords do not match.",
      "ACCEPT_BUTTON": "Activate account"
},
    TRANSLATOR: {
      SELECT: 'Select language',
    },
    GENERAL: {
      COMPANY_NAME: 'Kiubo Studios SL',
      LOADING: 'Please wait...',
      CONTINUE: 'Continue',
      ABOUT: 'About',
      CONTACT: 'Contact',
      EMAIL: 'Email',
      EMAIL_PLACEHOLDER: 'Enter your email',
      PASSWORD: 'Password',
      PASSWORD_PLACEHOLDER: 'Enter your password',
      SHOW_PASSWORD: 'Show password',
      HIDE_PASSWORD: 'Hide password',
      NAME: 'Name',
      CANCEL: 'Cancel',
      CLOSE: 'Close',
      RETRY: 'Try again',
      UPDATING: 'Updating…',
    },
    MENU: {
      TUTORIALS: 'Tutorials',
      VERSION: 'Version {{version}}',
      NAVIGATION: 'Game Center navigation',
      COLLAPSE_SIDEBAR: 'Collapse sidebar',
      EXPAND_SIDEBAR: 'Expand sidebar',
      GAME_SECTION: 'Game',
      CONFIG_SECTION: 'Configuration',
      MANAGEMENT_SECTION: 'Management',
      ADMIN_SECTION: 'Administration',
    },
    PAGINATOR: {
      LABEL: 'Pagination',
      ITEMS_PER_PAGE: 'Items per page',
      PER_PAGE: '{{count}} per page',
      PREVIOUS: 'Previous page',
      NEXT: 'Next page',
      PAGE: 'Page {{page}}',
      SUMMARY: {
        GAME_ONE: 'Showing {{first}} to {{last}} of {{count}} game',
        GAME_OTHER: 'Showing {{first}} to {{last}} of {{count}} games',
        VIDEO_ONE: 'Showing {{first}} to {{last}} of {{count}} video',
        VIDEO_OTHER: 'Showing {{first}} to {{last}} of {{count}} videos',
        USER_ONE: 'Showing {{first}} to {{last}} of {{count}} user',
        USER_OTHER: 'Showing {{first}} to {{last}} of {{count}} users',
      },
      TOTAL: {
        GAME_ONE: '{{count}} game',
        GAME_OTHER: '{{count}} games',
        VIDEO_ONE: '{{count}} video',
        VIDEO_OTHER: '{{count}} videos',
        USER_ONE: '{{count}} user',
        USER_OTHER: '{{count}} users',
      },
    },
    CATALOG: {
      TITLE: 'Design Catalog',
      SURFACE_TITLE: 'Interface reference',
      DESCRIPTION: 'Reference view for design and QA. Visible only in non-production environments.',
      ENVIRONMENT: 'env',
      INPUT: 'Input',
      SELECT: 'Select',
      TYPE_SOMETHING: 'Type something',
      TOGGLE_DESCRIPTION: 'Kiubo-style toggle (see styles.scss)',
      BRAND_FONT: 'custom font for brand titles',
      ICON_BUTTON_STATES: 'neutral, loading and destructive states',
      HOVER_ME: 'Hover me',
      ALIGN_END: 'Align end',
      NOTIFICATION_DESCRIPTION: 'Use these buttons to emit a test notification through the global notification bar.',
      ERROR_MOCK: '404 preview',
      PAGE_NOT_FOUND: 'Page not found',
      SYSTEM_ERROR: 'System error',
      NOT_FOUND_MESSAGE: 'We could not find what you were looking for.',
      DISABLED: 'disabled',
      ARCHIVE: 'Archive',
      EXAMPLE_TOGGLE: 'Example toggle',
      FORM_ERROR: 'form error feedback',
      NEUTRAL: 'neutral',
      CENTERED_TOOLTIP: 'Centered tooltip',
      END_TOOLTIP: 'End-aligned tooltip',
      ERROR: 'Error',
      ERROR_PREVIEWS: 'Error page previews',
      NAV: {
        LABEL: 'Design Catalog sections', COLORS: 'Colors', FOUNDATIONS: 'Foundations',
        COMPONENTS: 'Components', REFERENCE: 'Reference', ERRORS: 'Error states',
      },
      TYPE_USAGE: {
        DISPLAY: 'Hero numbers and major statements', PAGE_TITLE: 'Primary page heading',
        COMPONENT_TITLE: 'Cards and component headings', BODY_MEDIUM: 'Emphasized interface copy',
        BODY: 'Default interface copy', CAPTION: 'Metadata and supporting labels',
      },
      SECTIONS: {
        BRAND_PALETTE: 'Brand palette',
        STATES_NEUTRALS: 'States and neutrals',
        TYPOGRAPHY: 'Typography',
        BUTTONS: 'Buttons',
        FORMS: 'Forms',
        INFO_ROW: 'Info row',
        BADGES: 'Badges',
        NOTIFICATIONS: 'Notifications',
        CARD_TABLE: 'Data table',
        PAGINATOR: 'Paginator',
        ASIDE_ICONS: 'Aside icons',
        COMPONENT_INVENTORY: 'Component inventory',
        MAIN_PAGES: 'Main pages and modules',
        AUTH_SCREENS: 'Auth · screens',
        STATIC_PAGES: 'Static pages',
        SHARED_COMPONENTS: 'Shared components',
        LAYOUT: 'Layout (Kiubo shell)',
        TOOLTIP: 'Tooltip',
      },
      TABLE: {
        DESCRIPTION: 'Current compact data-grid pattern with loading and empty states.',
        CAPTION: 'Classification example',
        POSITION: 'Position', PLAYER: 'Player', SCORE: 'Score', MAX_WAVE: 'Max wave', GAMES: 'Games',
        LOADING_STATE: 'Loading', EMPTY_STATE: 'Empty', EMPTY: 'No results to display',
      },
      SWATCH: {
        CANVAS: 'Canvas', NAV_HEADER: 'Navigation / header', RAISED: 'Raised',
        SUNKEN_CONTROL: 'Sunken / control', OVERLAY: 'Overlay', HIGHLIGHT: 'KIUBO highlight',
        PRIMARY_ACTION: 'Primary action', PRIMARY_HOVER: 'Primary action hover',
        SECONDARY_TEXT: 'Secondary action text', SUBTLE_BORDER: 'Subtle border', DEFAULT_BORDER: 'Default border',
        SUCCESS: 'Success', WARNING: 'Warning', DANGER: 'Danger', INFO: 'Info',
        PRIMARY_TEXT: 'Primary text', SECONDARY_CONTENT: 'Secondary text',
        TERTIARY_TEXT: 'Tertiary text', DISABLED_TEXT: 'Disabled text',
      },
      USAGE: {
        APP_BACKGROUND: 'Application background', SHELL_SURFACES: 'Persistent shell surfaces',
        CARDS_PANELS: 'Cards and panels', INPUTS_NESTED: 'Inputs and nested areas',
        FLOATING_SURFACES: 'Menus and floating surfaces', BRAND_EMPHASIS: 'Brand emphasis and headers',
        PRIMARY_ACTIONS: 'Primary actions and selection', PRIMARY_HOVER: 'Primary action hover',
        SECONDARY_TEXT: 'Secondary interactive text', SUBTLE_BORDER: 'Low-emphasis separation',
        DEFAULT_BORDER: 'Surface separation', SUCCESS: 'Positive semantic state', WARNING: 'Warning semantic state',
        DANGER: 'Danger semantic state', INFO: 'Informational semantic state', IMPORTANT_CONTENT: 'Important content',
        SUPPORTING_CONTENT: 'Supporting content', METADATA: 'Metadata and descriptions', UNAVAILABLE_CONTENT: 'Unavailable content',
      },
    },
    DASHBOARD: {
      KICKER: 'Live sessions',
      TITLE: 'Active games',
      SURFACE_TITLE: 'Live sessions',
      TAGLINE_PRIMARY: 'Real players.',
      TAGLINE_SECONDARY: 'Real worlds.',
      ROOM_NAME: 'Game name',
      ROOM_EDIT: 'Game name',
      CREATED_AT: 'Start time',
      PROGRESS: 'Progress',
      NUM_GAMES: 'Maps played',
      HIDE: 'Move to History',
      SUCCESS_NAME: 'The game name has been successfully updated',
      ERROR_NAME: 'The game name could not be updated',
      ERROR_PDF_TITLE: 'PDF generation failed',
      ERROR_PDF_MESSAGE: "We couldn't generate the PDF. Please try again.",
      SUCCESS_DISABLE_ROOM: 'The game has been hidden',
      SUCCESS_ENABLE_ROOM: 'The game has been unarchived',
      SUCCESS_ENABLE_ROOM_TITLE: 'Game unarchived',
      SUCCESS_ENABLE_ROOM_MESSAGE: 'The game is available again.',
      SUCCESS_DISABLE_STATION: 'The station has been archived',
      SUCCESS_RENAME_STATION: 'The station has been renamed',
      ERROR_DISABLE_ROOM: 'The game could not be hidden',
      ERROR_ENABLE_ROOM: 'The game could not be unarchived',
      SUCCESS_DISABLE_ROOM_LIST: 'The selected games have been hidden',
      ERROR_DISABLE_ROOM_LIST: 'The selected games could not be hidden',
      SUCCES_REDIRECT: 'Back to homepage',
      LOADING: 'Loading',
      LOAD_ERROR: 'We could not load the active games.',
      NUM_PLAYERS: 'Players',
      ROOMS_EMPTY: 'No games available to display',
      ROOMS_EMPTY_IMAGE_ALT: 'No active games',
      DOWNLOAD: 'Download',
      DOWNLOAD_PDF: 'Download PDF',
      DOWNLOAD_PDF_FOR: 'Download PDF for {{room}}',
      ARCHIVE: 'Archive',
      MOVE_TO_HISTORY: 'Move to history',
      MOVE_TO_HISTORY_FOR: 'Move {{room}} to history',
      MOVE_SELECTED_TO_HISTORY: 'Move selected to history',
      GAMES_SELECTED_ONE: '{{count}} game selected',
      GAMES_SELECTED_OTHER: '{{count}} games selected',
      ARCHIVE_SELECTED_GAME_ONE: 'Archive {{count}} selected game',
      ARCHIVE_SELECTED_GAME_OTHER: 'Archive {{count}} selected games',
      SELECT_ALL_ROOMS: 'Select all games',
      SELECT_ROOM: 'Select {{room}}',
      OPEN_ROOM_DETAILS: 'View details for {{room}}',
      VIEW_DETAILS: 'View details',
      EDIT_ROOM_NAME: 'Edit game name for {{room}}',
      EDIT_PLAYER_NAME: 'Edit name for {{player}}',
      PLAYER_NAME_SCOPE: 'Applies to all games in this session.',
      PLAYER_NAME_ERROR_TITLE: 'Unable to change player name',
      PLAYER_NAME_ERROR: 'The name was not saved. Please try again.',
      PLAYER_NAME_CONFLICT: 'Another player in this session already uses that name.',
      ROOM_ID: 'ID: {{id}}',
      ACTIONS: 'Actions',
      ROOM_DETAIL_TABLE: 'Player scores',
      ROOM_DETAIL_EMPTY: 'No player scores available',
      ROOM_DETAIL_ERROR: 'Player scores could not be loaded',
      SELECT_ROOMS_TO_HISTORY: 'Select games to move to history',
      PLAYER_NAME: 'Player name',
      SCORE: 'Score',
      POSITION: 'Position',
      PLAYERS_ONE: '{{count}} player',
      PLAYERS_OTHER: '{{count}} players',
      MAPS_PLAYED_ONE: '{{count}} map played',
      MAPS_PLAYED_OTHER: '{{count}} maps played',
    },
    ROOM_HISTORICAL: {
      GROUP_COUNT_ONE: '{{count}} game',
      GROUP_COUNT_OTHER: '{{count}} games',
      INVALID_DATE: 'Enter a valid date including a four-digit year (YYYY-MM-DD).',
      TITLE: 'Game history',
      EMPTY: 'No history available',
      EMPTY_IMAGE_ALT: 'Empty history illustration',
      RESTORE: 'Restore game',
      RESTORE_FOR: 'Restore {{room}}',
      TABLE_CAPTION: 'Archived games',
      FILTERS: 'Filter game history',
      DATE_FILTER: 'Date',
      DATE_PLACEHOLDER: 'Any date range',
      SEARCH_PLACEHOLDER: 'Search by game name',
      OPEN_CALENDAR: 'Open calendar',
      HOUR_FILTER: 'Hour',
      ALL_DAY: 'All day',
      CLEAR_FILTER: 'Clear filter',
      LOAD_ERROR: 'We could not load the game history.',
    },
    STATIONS:{
      TITLE: 'Stations',
      SURFACE_TITLE: 'Registered stations',
      NAME: 'Station name',
      EDIT_NAME: 'Edit station name for {{station}}',
      DEVICE_ID: 'Device ID',
      TYPE: 'Type',
      LAST_USED: 'Last used',
      LEGACY: 'Legacy',
      TYPE_GAME_BOOTH: 'Game station',
      TYPE_STATION: 'Game station',
      TYPE_UNKNOWN: 'Unknown',
      NEVER: 'Never',
      ARCHIVE: 'Archive station',
      ARCHIVE_FOR: 'Archive {{station}}',
      TABLE_CAPTION: 'Stations',
      EMPTY: 'No stations registered',
      EMPTY_IMAGE_ALT: 'No registered stations',
      LOAD_ERROR: 'We could not load the stations.',
    },
    HELP: {
      TITLE: 'Help',
      LOAD_ERROR: 'We could not load the help content.',
      DESCRIPTION: 'Short tutorials and quick videos to help you operate KIUBO.',
      COMMUNITY: {
        TITLE: 'Community',
        DESCRIPTION: 'Join the community, ask questions, and share feedback.',
        ACCESS_DESCRIPTION: 'Access the private KIUBO community with your active platform session.',
        OPEN: 'Open community',
        DEMO_DENIED: 'Demo accounts cannot access the private community.',
      },
      PLAY: 'Play video',
    },
    LEADERBOARD: {
      TITLE: 'Leaderboard',
      LOAD_ERROR: 'We could not load the leaderboard.',
      SURFACE_TITLE: 'Top players in {{centerName}}',
      SUBTITLE_LIVE: 'Top players in {{centerName}}',
      POSITION: 'Position',
      PLAYER: 'Player',
      SCORE: 'Score',
      GAMES_PLAYED: 'Games played',
      MAX_WAVE: 'Max wave reached',
      WORLD_MAX_WAVE: 'Max wave reached in the world',
      CENTER_MAX_WAVE: 'Max wave reached in {{centerName}}',
      WORLD_RECORD: 'World record',
      CENTER_RECORD: '{{centerName}} record',
      OPEN_FULLSCREEN: 'Open in fullscreen',
      EMPTY: 'No scores recorded yet',
      POWERED_BY: 'Powered by',
    },
    REGISTER_BOOTH: {
      TITLE: "Box registration",
      DESCRIPTION: "Complete the registration process for your box",
      SUCCESS: 'Your box has been successfully registered',
      ERROR: 'Your box could not be registered',
      NAME: 'Box name',
      NAME_PLACEHOLDER: 'Enter box name',
      INVALID_TOKEN: 'An error occurred, please try again',
    },
    USER: {
      LOG_OUT: 'Log out'
    },
    AUTH: {
      PROFILE: {
        PERSONAL_DATA: 'Personal data',
        NAME_REQUIRED: 'Your name is required',
        LASTNAME_REQUIRED: 'Your last name is required',
        NAME_LENGTH: 'Your name must be at least {{ qty }} characters',
        LASTNAME_LENGTH: 'Your last name must be at least {{ qty }} characters',
        CENTER_DATA: 'Center data',
        SCORE_EDITOR_DATA: 'Ticket Editor',
        NAME: 'Full name',
        NAME_PLACEHOLDER: 'Name',
        LAST_NAME_PLACEHOLDER: 'Last name',
        EMAIL: 'Email address',
        EMAIL_PLACEHOLDER: 'Email address',
        EMAIL_REQUIRED: 'Email is required',
        ALLOW_MARKETING: 'Allow marketing',
        EMAIL_INVALID:  'Invalid email format',
        PROFILE_UPDATED: 'Profile successfully updated',
        SCORE_EDITOR: {
          TITLE: 'Preview',
          DESCRIPTION: 'This is how the ticket will look with the current configuration.',
          DOWNLOAD_PREVIEW: 'Download Preview',
          DOWNLOADING: 'Preparing PDF…',
          DOWNLOAD_ERROR: 'The preview could not be downloaded',
          CHANGE_IMAGE: 'Change center image',
          CLICK_TO_ADD_USER: 'Click to add a user',
          SLOGAN_LABEL: 'Ticket slogan',
          SAVE_HINT: 'Press Enter or the check to save',
          SAVE_CHANGES: 'Save changes',
          CENTER_IMAGE_UPDATED: 'The center image has been saved successfully',
          CENTER_IMAGE_REQUIREMENTS: 'PNG or JPG · Maximum 2 MB and 2000 × 2000 px',
          CENTER_IMAGE_INVALID_FORMAT: 'Invalid format. Select a PNG or JPG image.',
          CENTER_IMAGE_TOO_LARGE: 'The image exceeds the 2 MB size limit.',
          CENTER_IMAGE_DIMENSIONS_TOO_LARGE: 'The image exceeds the maximum dimensions of 2000 × 2000 px.',
          CENTER_IMAGE_INVALID: 'The image could not be read. Select a valid PNG or JPG file.',
          CENTER_IMAGE_FORBIDDEN: 'You do not have permission to change this center image.'
        },
        CENTER: {
          OVERVIEW: 'Center profile',
          FISCAL_DATA: 'Fiscal details',
          FISCAL_DATA_DESCRIPTION: 'Legal information and billing address for the center.',
          PUBLIC_DATA: 'Public information',
          PUBLIC_DATA_DESCRIPTION: 'Details used to identify and find your center.',
          READ_ONLY: 'Read only',
          OPTIONAL: 'optional',
          NAME: 'Name',
          NAME_REQUIRED: 'Your center name is required',
          WEB_REQUIRED: 'Your website field is required',
          WEB_INVALID: 'Website format is incorrect (http://example.com)',
          FB_INVALID: 'Facebook format is incorrect (http://facebook.com/example)',
          NAME_PLACEHOLDER: 'Your center name',
          WEB_PLACEHOLDER: 'Your center website',
          NAME_LENGTH: 'Your center name must be at least {{ qty }} characters',
          CHARACTERES: 'characters',
          VAT: 'VAT ID',
          VAT_PLACEHOLDER: 'Center VAT ID',
          ADDRESS_1: 'Address 1',
          ADDRESS_1_PLACEHOLDER: 'Address 1',
          ADDRESS_2: 'Address 2',
          ADDRESS_2_PLACEHOLDER: 'Address 2',
          POSTAL_CODE: 'Postal Code',
          POSTAL_CODE_PLACEHOLDER: 'Postal Code',
          COUNTRY: 'Country',
          COUNTRY_ES: 'Spain',
          WEB: 'Website',
          FACEBOOK: 'Facebook',
          FACEBOOK_PLACEHOLDER: 'Your center’s Facebook, so we can follow you ;P',
          SLOGAN: 'Slogan',
          SLOGAN_PLACEHOLDER: 'Your center’s slogan',
          CENTER_UPDATED: 'Center successfully updated',
          SUPPORT_TITLE: 'Need to update these details?',
          CANNOT_EDIT: 'Request the change from the Technical Support team.',
          CONTACT_SUPPORT: 'Contact support',
          SLOGAN_TOO_LONG: "The slogan cannot exceed {{ qty }} characters.",
          SLOGAN_EMPTY: 'The slogan cannot be empty',
          SLOGAN_UPDATED: 'Slogan successfully updated',
          SLOGAN_ERROR: 'Error updating slogan',
          IMAGE_UPDATED: 'Image successfully updated',
        },
      },
      GENERAL: {
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: 'Don’t have an account?',
        SIGNUP_BUTTON: 'Sign up',
        FORGOT_BUTTON: 'Forgot your password?',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
        SAVE: 'Save'
      },
      LOGIN: {
        TRY: 'Want to try the platform?',
        WELCOME: 'Welcome to GameCenter',
        NOT_ACCOUNT: 'Don’t have an account?',
        TITLE: 'Create an account',
        BUTTON: 'Sign up',
        USE_DEMO: 'Use demo account',
      },
      COMMUNITY_CONNECT_ERROR: 'Could not sign in to the community',
      LEGAL_ACCEPTANCE: {
        TITLE: 'Updated legal conditions',
        INTRO: 'Please review and accept the updated documents to continue using KIUBO.',
        LOADING: 'Loading…',
        DOCUMENT_META: 'Version {{version}} · Effective {{date}}',
        CONSENT: 'I have read and accept the documents shown above.',
        SAVING: 'Saving…',
        ACCEPT: 'Accept and continue',
        SIGN_OUT: 'Sign out',
        LOAD_ERROR: 'The legal documents could not be loaded.',
        SAVE_ERROR: 'The acceptance could not be saved. Please try again.',
      },
      VERIFY_EMAIL: {
        DETAIL: 'Your email has been verified. You can now sign in.',
      },
      SOCIAL: {
        OR: 'or continue with',
        CONTINUE_WITH_GOOGLE: 'Continue with Google',
        CONTINUE_WITH_FACEBOOK: 'Continue with Facebook',
        SIGNING_IN: 'Signing in…',
      },
      FORGOT: {
        TITLE: 'Forgot your password?',
        DESC: 'Enter your email to reset your password',
        SENT: 'The reset password has been sent. Please check your email',
        SUCCESS: 'Your account has been successfully reset.'
      },
      PASSWORD_RESET: {
        TITLE: "Reset password",
        DESC: "Enter your new password",
        PASSWORD: "Password",
        CONFIRM_PASSWORD: "Confirm password",
      },
      PASSWORD_RESET_SUCCESS: {
        TEXT: "Your password has been successfully updated",
        ACTION: "Go to login"
      },
      FORGOT_SUCCESS: {
        TEXT: "An email has been sent to reset your password"
      },
      REGISTER: {
        TITLE: 'Sign up',
        TITLE_2: 'Create your account',
        ACCOUNT_STEP: 'Account',
        CENTER_STEP: 'Game Center',
        STEP_ONE_OF_TWO: 'Step 1 of 2',
        STEP_TWO_OF_TWO: 'Step 2 of 2',
        ACCOUNT_STEP_HINT: 'Your login details',
        CENTER_STEP_HINT: 'Your business details',
        CONTINUE: 'Continue',
        BACK: 'Back',
        CENTER_TITLE: 'Tell us about your Game Center',
        CENTER_SUPPORT: 'We need a few details to configure your KIUBO account.',
        CREATE_ACCOUNT: 'Create account',
        PASSWORD_HELP: 'Use at least 8 characters, one uppercase letter, and one number.',
        REQUIRED_CONSENT: 'Required',
        OPTIONAL_CONSENT: 'Optional',
        PROGRESS: 'Registration progress',
        MARKETING_CONSENT: 'I would like to receive KIUBO product updates and commercial communications.',
        NAME: 'Name',
        LAST_NAME: 'Last name',
        HAVE_ACCOUNT: 'Already have an account?',
        SIGN_IN: 'Sign in',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfully registered.',
        CENTER_NAME: 'Center name',
        VAT: 'VAT ID',
        FACEBOOK: "Facebook",
        FACEBOOK_PLACEHOLDER: "Enter the URL of your Facebook page",
        WEB: "Website",
        WEB_PLACEHOLDER: "Enter your website URL",
        ADDRESS_1: 'Address 1',
        ADDRESS_2: 'Address 2',
        ADDRESS_2_OPTIONAL: 'Address 2 (optional)',
        ADD_ADDRESS_2: 'Add address line 2',
        EMAIL_EXISTS_INLINE: 'An account already exists with this email.',
        POSTAL_CODE: 'Postal Code',
        SELECT_COUNTRY: 'Select country',
        LEGAL_PRE: 'I accept the',
        LEGAL: 'terms and conditions',
        LEGAL_POST: 'and',
        PRIVACY_POLICY: 'privacy policy',
        SUPPORT_TEXT: 'If you are having trouble registering, we can help by email.',
        SUPPORT_CTA: 'Email us at kiubo.studios@gmail.com',
        TERMS_CONDITIONS_TITLE: 'Terms and Conditions',
        PRIVACY_POLICY_TITLE: 'Privacy Policy'
      },
      REGISTER_SUCCESS: {
        TITLE: 'Check your email',
        TEXT: 'Your account has been created successfully.',
        DETAIL: "We've sent you a verification link to confirm your email address. Verify your address before signing in.",
        ACTION: 'Back to sign in'
      },
      VERIFY_EMAIL_SUCCESS: {
        TEXT: "Your email has been successfully validated",
        ACTION: "Go to login"
      },
      INPUT: {
        FULLNAME: 'Full name',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm password',
        USERNAME: 'Username'
      },
      VALIDATION: {
        INVALID: '{{name}} is invalid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: 'The minimum length for {{name}} is {{min}}',
        AGREEMENT_REQUIRED: 'You must accept the terms and conditions',
        NOT_FOUND: 'The requested {{name}} was not found',
        INVALID_LOGIN: 'Login details are incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'The field is invalid',
        PASSWORD_NOT_MATCH: 'Password and confirmation do not match.',
        CONFIRM_PASSWORD: 'Password confirmation does not match the password.',
        PASSWORD_STRENGTH: 'Use at least 8 characters, one uppercase letter, and one number.',
      }
    },
    BOOTH: {
      TITLE: "Box"
    },
    ERROR: {
      AUTH_CREDENTIALS: 'Incorrect username or password',
      AUTH_EMAIL_VALIDATION: 'Email not verified. If you have not received the email, write to kiubo.studios@gmail.com',
      AUTH_ACCOUNT_VALIDATION: 'Your center is being validated, if validation takes too long, write to kiubo.studios@gmail.com',
      AUTH_FORGOT: 'Sorry, some errors were detected, please try again',
      BOOTH_NOT_CREATED: 'Could not be created, check your Internet connection and try again. If the problem persists, write to kiubo.studios@gmail.com',
      REGISTER: 'Registration data is incorrect',
      DEFAULT_VALIDATION: '{{field}} invalid',
      FORBIDDEN: 'Access not allowed',
      NOT_FOUND: 'Not found',
      UNKNOWN: 'Oops! Looks like we have a problem',
      NETWORK: 'No Internet connection. Check your connection and try again.',
      TIMEOUT: 'The request took too long. Please try again.',
      CONFLICT: 'The data has changed or conflicts with another operation. Refresh and try again.',
      RATE_LIMIT: 'Too many requests. Please wait a moment and try again.',
      SERVER: 'The service is temporarily unavailable. Please try again later.',
      DEFAULT_EMPTY: 'No data to display',
      UNKNOWN_DESCRIPTION: 'Unknown error or temporary issue, if it persists, write to kiubo.studios@gmail.com',
      REQUIRED_FIELD: 'Please fill in the field',
      INVALID_FORMAT_EMAIL: 'Email format is invalid',
      PASSWORD_MISMATCH: 'Passwords must match',
      MIN_LENGTH: 'Minimum field characters are',
      ERROR_UPDATING: 'Error updating data, please try again',
      INCORRECT_FORM: 'The form is invalid',
      AUTH_EMAIL_EXISTS: 'Email is already registered',
      AUTH_OLD_PASSWORD_REQUIRED: 'Current password is required',
      AUTH_OLD_PASSWORD_INVALID: 'Current password is incorrect',
      AUTH_TEMP_TOKEN_INVALID: 'Temporary token is invalid',
      AUTH_ERROR: 'Error',
      REGISTER_CREATE_FAILED: "We couldn't create your account",
      REGISTER_CREATE_FAILED_DETAIL: 'Something went wrong while creating your account. Please try again.',
      AUTH_SOCIAL_DISABLED: 'Social login is currently disabled.',
      AUTH_SOCIAL_NOT_CONFIGURED: 'Social login is not configured for this environment.',
      AUTH_SOCIAL_CANCELLED: 'The social login was cancelled before finishing.',
      AUTH_SOCIAL_FAILED: 'Could not complete the social login. Please try again.',
      AUTH_SOCIAL_TOKEN_INVALID: 'The provider token could not be verified.',
      AUTH_SOCIAL_EMAIL_MISSING: 'The provider did not share an email address.',
      AUTH_SOCIAL_PROVIDER: 'Unsupported social provider.',
      INVALID_FACEBOOK_URL: "The Facebook URL is not valid. It must look like 'https://www.facebook.com/your-page'.",
      INVALID_URL: "The URL is not valid. It must look like 'https://www.your-site.com'.",
      TERMS_CONDITIONS_REQUIRED: 'You must accept the terms and conditions to continue'
    },
    PUBLIC_ERROR: {
      NOT_FOUND_TITLE: 'Page not found',
      NOT_FOUND_DESCRIPTION: 'We could not find the page you were looking for.',
      SYSTEM_TITLE: 'System error',
      SYSTEM_DESCRIPTION: 'Something went wrong. Please try again later.',
      GO_HOME: 'Go to homepage',
    }
  }
};
